import { render, staticRenderFns } from "./MRadio.vue?vue&type=template&id=10f3d041&"
import script from "./MRadio.vue?vue&type=script&lang=js&"
export * from "./MRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports